const Master = require('./Master');
const Visa = require('./Visa');
const Amex = require('./Amex');
const Naranja = require('./Naranja');
const Maestro = require('./Maestro');
const Cabal = require('./Cabal');
const Cencosud = require('./Cencosud');
const Cordobesa = require('./Cordobesa');
const Argencard = require('./Argencard');
const Diners = require('./Diners');
const Tarshop = require('./Tarshop');
const CMR = require('./CMR');
const Rapipago = require('./Rapipago');
const Pagofacil = require('./Pagofacil');

module.exports = {
  Master,
  Visa,
  Amex,
  Naranja,
  Maestro,
  Cabal,
  Cencosud,
  Cordobesa,
  Argencard,
  Diners,
  Tarshop,
  CMR,
  Rapipago,
  Pagofacil,
};
